// extracted by mini-css-extract-plugin
module.exports = {"degree":"vbV-"};